import React from 'react'
import { useTranslation } from 'react-i18next'
import GenericStatsDetails from './GenericStatsDetails'

const Orders: React.FC = () => {
  const { t } = useTranslation()

  return <GenericStatsDetails entity='order' entityTranslation={t('global.stats.orders')} icon='dolly' />
}

export default Orders
